import React from 'react';
import Modal from '@/ctComponents/Modal';
import { createPortal } from 'react-dom';

export default ({ show, handleDelete, closePopup, loading = false }) => {
  const handleClose = () => {
    closePopup();
  };

  const handleSubmit = () => {
    handleDelete();
  };

  if (!show) return null;

  return createPortal(
    <Modal
      show={show}
      children={
        <span
          style={{
            textAlign: 'center',
            width: '100%',
            marginTop: '24px',
          }}>
          Are you sure that you want to delete it?
        </span>
      }
      submitText={'Yes, Delete'}
      icon={'deleteIcon'}
      title={'Delete Member'}
      setShow={handleClose}
      submit={handleSubmit}
      loadingbutton={loading}
      customHandleClose={handleClose}
      noX={false}
    />,
    document.body
  );
};
